import { Trans } from "@lingui/react/macro";
import styles from "./Reporting.module.scss";
import { Heading } from "@medoma/components/Heading/Heading";
import { Outlet } from "react-router";
import { Tab, TabList, TabPanel } from "@medoma/components/Tabs";
import { manualInvoicingEnabled } from "@medoma/models/organizations";
import { useUserProfile } from "@/api/Users";

const Header = () => {
  const { organization } = useUserProfile();

  return (
    <header className={styles.reportingPageHeader}>
      <div className={styles.reportingPageTitleRow}>
        <Heading level="h1">
          <Trans>Rapportering</Trans>
        </Heading>
      </div>

      {!manualInvoicingEnabled(organization) ? (
        <TabList>
          <Tab to="to-handle">
            <Trans>Att hantera</Trans>
          </Tab>
          <Tab to="pending">
            <Trans>På väg till GVR</Trans>
          </Tab>
          <Tab to="generate-report">
            <Trans>Generera rapport</Trans>
          </Tab>
        </TabList>
      ) : null}
    </header>
  );
};

export const Reporting = () => {
  return (
    <div className={styles.reportingPage}>
      <Header />
      <div className={styles.reportingPageContent}>
        <TabPanel>
          <Outlet />
        </TabPanel>
      </div>
    </div>
  );
};
